import PropTypes from 'prop-types';
import { Card, CardContent, Divider, Stack, Typography } from '@mui/material';

export default function AdminDetailPanel({ title, items }) {
  return (
    <Card variant="outlined">
      <CardContent>
        <Stack spacing={2}>
          <Typography variant="subtitle1">{title}</Typography>
          <Divider />
          <Stack spacing={1.5}>
            {items.map((item) => (
              <Stack key={item.label} direction="row" justifyContent="space-between" spacing={2}>
                <Typography variant="body2" color="text.secondary">
                  {item.label}
                </Typography>
                <Typography variant="body2" fontWeight={600} textAlign="right">
                  {item.value}
                </Typography>
              </Stack>
            ))}
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}

AdminDetailPanel.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  title: PropTypes.string.isRequired,
};
